import axios from "axios";
import Config from "../../config/";
import moment from "moment";
const API_KEY = Config.apikey;
const ROOT_URL = Config.rooturl;

export function cekAuth() {
  return {
    headers: {
      Authorization: API_KEY + localStorage.getItem("token"),
      "Content-Type": "multipart/form-data"
    }
  };
}

function pushloggingx(requests, description) {
  const url = `${ROOT_URL}logactivity/logactivity/`;
  let ippublic = "-";

  const fdata = new FormData();
  fdata.append("user_id", localStorage.getItem("id"));
  fdata.append("name", localStorage.getItem("name"));
  fdata.append("email", localStorage.getItem("email"));
  fdata.append("issuperuser", localStorage.getItem("is_superuser"));
  fdata.append("ipaddress", localStorage.getItem("ipaddress"));
  fdata.append("location", localStorage.getItem("location"));
  fdata.append("date_created", moment().format("YYYY-MM-DD HH:mm:ss"));
  fdata.append("os", "");
  fdata.append("activity", requests);
  fdata.append("description", description);

  const request = axios.post(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  return request;
}

export function fetchPOIPort() {
  const url = `${ROOT_URL}poi/poi/?search=port&limit=1000`;
  const request = axios.get(url, cekAuth());
  pushloggingx("get " + url, "Akses halaman Masterdata (Port)");
  return request;
}

export function deletePort(id) {
  const url = `${ROOT_URL}poi/poi/${id}/`;

  const request = axios.delete(url, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  pushloggingx("delete " + url, "Menghapus data port");
  return request;
}

export function pushPort(body) {
  const url = `${ROOT_URL}poi/poi/`;

  const fdata = new FormData();
  fdata.append("name", body.name);
  fdata.append("address", body.address);
  fdata.append("gid", Math.floor(Math.random() * 10000));
  fdata.append("description", body.description);
  fdata.append("category", "port");
  fdata.append("district", body.district);
  fdata.append("subdistrict", body.subdistrict);
  fdata.append("dimensi", body.dimensi);
  fdata.append("subdimensi", body.subdimensi);
  fdata.append("latitude", body.latitude);
  fdata.append("longitude", body.longitude);
  fdata.append("id_district", "");
  fdata.append("id_subdistrict", "");
  fdata.append("imgpath", "");
  fdata.append("iconpath", "");
  fdata.append("sorting", "");

  fdata.append("dateCreated", moment().format("YYYY-MM-DD"));
  const request = axios.post(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  pushloggingx("post " + url, "Menambahkan data port");
  return request;
}

export function updatePort(body) {
  const url = `${ROOT_URL}poi/poi/${body.id}/`;

  const fdata = new FormData();
  fdata.append("name", body.name);
  fdata.append("address", body.address);
  fdata.append("gid", Math.floor(Math.random() * 10000));
  fdata.append("description", body.description);
  fdata.append("category", "port");
  fdata.append("district", body.district);
  fdata.append("subdistrict", body.subdistrict);
  fdata.append("dimensi", body.dimensi);
  fdata.append("subdimensi", body.subdimensi);
  fdata.append("latitude", body.latitude);
  fdata.append("longitude", body.longitude);
  fdata.append("id_district", "");
  fdata.append("id_subdistrict", "");
  fdata.append("imgpath", "");
  fdata.append("iconpath", "");
  fdata.append("sorting", "");

  fdata.append("dateCreated", moment().format("YYYY-MM-DD"));
  const request = axios.put(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  pushloggingx("update " + url, "Mengedit data port");
  return request;
}

export function proccessUpload(fileupload, ext) {
  const url = `${ROOT_URL}fileupload/uploadfile/`;

  const fdata = new FormData();
  fdata.append("fileupload", fileupload);
  fdata.append("ext", ext);

  const request = axios.post(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });

  return request;
}
